// extracted by mini-css-extract-plugin
module.exports = {"gridItem":"grid-item-module--gridItem--v-sdl","gridItemDark":"grid-item-module--gridItemDark--1eBNu","gridItemLight":"grid-item-module--gridItemLight--Zjsfp"};